import React, { ChangeEvent, SyntheticEvent } from "react";
import { QueryInput, Submit, Form } from "./styles/searchFormStyles";

interface SearchFormProps {
  query: string;
  handleSubmit: (evt: SyntheticEvent) => Promise<void>;
  handleInputChange: (evt: ChangeEvent<HTMLInputElement>) => void;
}

const SearchForm = (props: SearchFormProps) => {
  const { query, handleSubmit, handleInputChange } = props;

  return (
    <Form onSubmit={handleSubmit}>
      <QueryInput
        type="text"
        placeholder="Wpisz miejscowość / kod pocztowy"
        onChange={evt => handleInputChange(evt)}
        value={query}
      />
      <Submit type="submit" value="" />
    </Form>
  );
};

export default SearchForm;
